import { useFeatureFlagEnabled } from 'posthog-js/react'
import { useParams } from 'react-router'
import { useEntevatePermission, usePermission } from 'utils'

export type FeatureFlag = 'content' | 'ai-summaries' | 'on-the-go'

export function useFeature(flag: FeatureFlag) {
  const allWorkspaces = useParams().workspaceId === 'all'
  const enabled = useFeatureFlagEnabled(flag)
  const permission = usePermission()
  const [entevatePermission] = useEntevatePermission()

  switch (flag) {
    case 'ai-summaries':
      if (entevatePermission === 'entevate') return true
      return enabled

    case 'content':
      if (allWorkspaces) return false
      if (entevatePermission === 'entevate') return true
      return enabled && permission.content !== 'viewer'

    case 'on-the-go':
      if (entevatePermission === 'entevate') return true
      return enabled
  }
}
